import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

export default CheckRoundedIcon;
